/**
 * 複数の白背景エリアとヘッダーの交差を監視して、
 * 交差している部分と非交差部分で色を切り替える
 */
const initHeaderTransition = () => {
    const blueHeader = document.querySelector(".header__right.invert");
    const normalHeader = document.querySelector(".header__right:not(.invert)");
    // const whiteAreas = document.querySelectorAll(".whitebg");
    const whiteAreas = document.querySelectorAll(".bluebg");
    let headerHeight = blueHeader.offsetHeight;
    let ticking = false;

    const generateMergedClipPath = (ranges, height) => {
        const points = ranges.flatMap((range) => {
            const topY = Math.max(
                0,
                Math.min(100, (range.start / height) * 100)
            );
            const bottomY = Math.max(
                0,
                Math.min(100, (range.end / height) * 100)
            );
            return [
                `0 ${topY}%`,
                `100% ${topY}%`,
                `100% ${bottomY}%`,
                `0 ${bottomY}%`,
            ];
        });

        return `polygon(${points.join(", ")})`;
    };

    const updateClipPath = () => {
        headerHeight = blueHeader.offsetHeight;
        const whiteRects = Array.from(whiteAreas).map((area) =>
            area.getBoundingClientRect()
        );

        const overlappingRanges = whiteRects
            .map((rect) => ({
                start: Math.max(0, rect.top),
                end: Math.min(headerHeight, rect.bottom),
            }))
            .filter((range) => range.end > 0 && range.start < headerHeight);

        if (overlappingRanges.length === 0) {
            // 重なりがない場合
            blueHeader.style.clipPath = "inset(100% 0 0 0)";
            normalHeader.style.clipPath = "inset(0 0 0 0)";
            return;
        }

        // 複数のrangeをマージする
        const mergedRange = overlappingRanges.reduce((acc, range) => ({
            start: Math.min(acc.start, range.start),
            end: Math.max(acc.end, range.end),
        }));

        // パーセンテージに変換
        const topPercent = (mergedRange.start / headerHeight) * 100;
        const bottomPercent = 100 - (mergedRange.end / headerHeight) * 100;

        // blueHeaderの表示範囲を設定
        if (mergedRange.end > mergedRange.start) {
            blueHeader.style.clipPath = `inset(${topPercent}% 0 ${bottomPercent}% 0)`;

            // normalHeaderの逆パターン
            if (topPercent > 0 || bottomPercent > 0) {
                normalHeader.style.clipPath = `polygon(
              0 0, 
              100% 0, 
              100% ${topPercent}%, 
              0 ${topPercent}%,
              0 ${100 - bottomPercent}%, 
              100% ${100 - bottomPercent}%, 
              100% 100%, 
              0 100%
            )`
                    .replace(/\s+/g, " ")
                    .trim();
            } else {
                normalHeader.style.clipPath = "inset(100% 0 0 0)";
            }
        }
    };

    let resizeTimeout;
    const handleResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            updateClipPath();
        }, 100);
    };

    window.addEventListener("scroll", () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateClipPath();
                ticking = false;
            });
            ticking = true;
        }
    });

    window.addEventListener("resize", handleResize);
    updateClipPath();

    return () => {
        window.removeEventListener("scroll", updateClipPath);
        window.removeEventListener("resize", handleResize);
    };
};

// 実行
initHeaderTransition();

const blueHeader = document.querySelector(".header__right:not(.invert)");
const normalHeader = document.querySelector(".header__right.invert");

const blueHeaderLinks = blueHeader?.querySelectorAll("a") || [];
const normalHeaderLinks = normalHeader?.querySelectorAll("a") || [];

// インデックスごとに対応するリンクを同期させる
blueHeaderLinks.forEach((link, index) => {
    const correspondingLink = normalHeaderLinks[index];

    // マウスオーバー時の処理
    link.addEventListener("mouseenter", () => {
        if (correspondingLink) {
            correspondingLink.classList.add("hover");
        }
        link.classList.add("hover");
    });

    // マウスアウト時の処理
    link.addEventListener("mouseleave", () => {
        if (correspondingLink) {
            correspondingLink.classList.remove("hover");
        }
        link.classList.remove("hover");
    });

    // 反対側のリンクにも同じイベントリスナーを追加
    if (correspondingLink) {
        correspondingLink.addEventListener("mouseenter", () => {
            link.classList.add("hover");
            correspondingLink.classList.add("hover");
        });

        correspondingLink.addEventListener("mouseleave", () => {
            link.classList.remove("hover");
            correspondingLink.classList.remove("hover");
        });
    }
});
